<template>
  <div id="Section" class="section">
    <h1>{{ title }}</h1>
    <a
      v-if="type && type === 109"
      class="link"
      href="https://mp.weixin.qq.com/s/3k7m31dGJ3cKhHPZlRkJUg"
    >
      250 小时学完中学六年，了解暗示法英语的奥妙
      <i class="anyteachicon anyteach-next1" />
    </a>
    <h2 v-else>{{ subtitle }}</h2>
    <div class="content">
      <div v-for="item in data" :key="item.key" class="item" @click="redirect(item.url)">
        <div class="img" v-lazy:background-image="item.bgd" />
        <div class="meta">
          <h3>
            <span class="title">{{ item.title }}</span>
          </h3>
          <h4 v-if="item.events" class="price">{{ getPrice(item.events) }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Section",
  props: ["title", "subtitle", "type", "data"],
  methods: {
    getPrice(events) {
      const minPrice = events.reduce((accumulator, value) => {
        if (value.price < accumulator && value.is_demo == 0) {
          accumulator = value.price
        }
        return accumulator
      }, events[0].price)
      const maxPrice = events.reduce((accumulator, value) => {
        if (value.price > accumulator) {
          accumulator = value.price
        }
        return accumulator
      }, events[0].price)
      if (maxPrice === minPrice && maxPrice != 0) return `¥ ${minPrice}`
      else if (maxPrice != minPrice && maxPrice != 0) return `¥ ${minPrice} 起`
      return "免费"
    },
    redirect(url) {
      if (url.includes("http")) {
        return window.location.replace(url)
      }
      return this.$router.push(url)
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";

#Section {
  &:first-of-type {
    margin-top: 15px;
  }
  .content {
    overflow: auto;
    white-space: nowrap;
    margin-left: -5%;
    .item:first-child {
      margin-left: 5%;
    }
    .item {
      display: inline-block;
      width: 150px;
      min-height: 160px;
      margin-right: 15px;
      vertical-align: top;
      transition: all 0.1s;
      &:active {
        opacity: 0.7;
      }
      .meta {
        white-space: -moz-pre-wrap !important;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        white-space: pre-wrap;
        word-wrap: break-word;
        white-space: -webkit-pre-wrap;
        word-break: break-all;
        white-space: normal;
        padding: 5px 0;

        h3 {
          width: 100%;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 5px 0 2px 0;
          .title {
            line-height: 1.3;
            font-size: 0.9rem;
          }
        }
        h3.news-title {
          -webkit-line-clamp: 2;
        }
        h4 {
          font-size: 0.8rem;
          color: $red;
          line-height: 1.3;
          @include avenir-demi();
          margin: 0;
        }
      }
      .img {
        margin-top: 15px;
        width: 150px;
        height: 100px;
        border-radius: 5px;
        box-shadow: 0 0 25px 0 #efefef;
        display: block;
        background: #eee;
        background-position: center;
        background-size: cover;
        display: block;
      }
    }
  }

  @media only screen and (min-device-width: 768px) {
    h1 {
      font-size: 1.5rem;
    }
    h2 {
      font-size: 1rem;
    }
    .content {
      .item {
        width: 250px;
        .img {
          height: 150px;
          width: auto;
        }

        .meta {
          h3 {
            font-size: 1rem;
            width: 102%;
          }
          h4 {
            font-size: 1rem;
          }
        }
      }
    }
    .news-item-wrapper {
      .news-item {
        width: 250px;
      }
    }
  }
}
</style>
